import React, { useState } from 'react';

import Row from 'components/Row';
import { Input } from 'components/Inputs/Input';
import { GoogleButton } from 'components/Buttons/SocialButton';
import { PrimaryButton } from 'components/Buttons/PrimaryButton';
import { OutlineButton } from 'components/Buttons/OutlineButton';
import { FacebookButton } from 'components/Buttons/SocialButton';
import {
  AuthCardTitle,
  AuthCardSubTitle,
  Divider,
  LinkContainer
} from '../styled';
import {
  facebookSignInProvider,
  googleSignInProvider,
  addUserToFirestore
} from '../firebase';
import { authRef } from 'api';

export default function LoginPage({ history }) {
  const [form, setForm] = useState({
    email: '',
    password: ''
  });

  const handleInput = event => {
    setForm({
      ...form,
      [event.target.name]: event.target.value
    });
  };

  async function submit(e) {
    e.preventDefault();
    var user = await authRef.signInWithEmailAndPassword(
      form.email,
      form.password
    );
    addUserToFirestore(user.user);
  }

  return (
    <React.Fragment>
      <AuthCardTitle>Welcome to Medilink</AuthCardTitle>
      <AuthCardSubTitle>Sign up to save your progress</AuthCardSubTitle>
      <Row justify="space-evenly">
        <FacebookButton
          onClick={async () => {
            try {
              var user = await authRef.signInWithPopup(facebookSignInProvider);
              addUserToFirestore(user.user);
            } catch (e) {
              alert(e.message);
            }
          }}
        />
        <GoogleButton
          onClick={async () => {
            try {
              var user = await authRef.signInWithPopup(googleSignInProvider);
              addUserToFirestore(user.user);
            } catch (e) {
              alert(e.message);
            }
          }}
        />
      </Row>
      <Divider>Or</Divider>
      <form onSubmit={submit}>
        <Input
          required
          type="email"
          id="outlined-email"
          label="Email"
          name="email"
          onChange={handleInput}
          margin="normal"
        />
        <Input
          required
          id="outlined-password"
          label="Password"
          name="password"
          type="password"
          onChange={handleInput}
          margin="normal"
        />
        <LinkContainer>
          <span onClick={() => history.push('/fp')}>Forgot Password?</span>
        </LinkContainer>
        <Row justify="space-between">
          <PrimaryButton marginright="0" type="submit">
            SIGN IN
          </PrimaryButton>
          <OutlineButton onClick={() => history.push('/signup')}>
            SIGN UP
          </OutlineButton>
        </Row>
      </form>
    </React.Fragment>
  );
}
